import { render, staticRenderFns } from "./El_Materials_and_Finishes.vue?vue&type=template&id=f07a01ca&scoped=true"
import script from "./El_Materials_and_Finishes.vue?vue&type=script&setup=true&lang=js"
export * from "./El_Materials_and_Finishes.vue?vue&type=script&setup=true&lang=js"
import style0 from "./El_Materials_and_Finishes.vue?vue&type=style&index=0&id=f07a01ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f07a01ca",
  null
  
)

export default component.exports